// URL-based preloader for images under `public/images`.
// This approach works across bundlers because it loads images by URL instead
// of using dynamic `import()` which may not support `public/` paths.

// NOTE: this file was generated from a static scan of `src/` for `/images/...` usages.
// It preloads only files referenced in the codebase (and reasonable expansions
// for indexed template usages).

export const preloadIcons = async () => {
  const paths = [
    "/images/logo.svg",
    "/images/moovez_frog.png",
    "/images/Moovez-Dark.svg",
    "/images/friend.png",
    "/images/moovez_blog_logo.svg",
    "/images/sign_avtar.svg",
    "/images/MoovezBlogImage.png",
    "/images/blog_0.png",
    "/images/blog_1.png",
    "/images/blog_0_0.png",
    "/images/blog_1_0.png",
    "/images/cargovan.png",
    "/images/driver.png",
    "/images/ceo.png",
    "/images/ourStory_banner.png",
    "/images/book_a_mover_banner.png",
    "/images/tooltip.svg",
    "/images/quote.svg",
    "/images/user.svg",
    "/images/userGreen.svg",

    // NewUiIcons
    "/images/NewUiIcons/Add Icon.svg",
    "/images/NewUiIcons/AddIcon.svg",
    "/images/NewUiIcons/AddNoteIcon.svg",
    "/images/NewUiIcons/addtionalnoteicon.svg",
    "/images/NewUiIcons/ApplePay.svg",
    "/images/NewUiIcons/Arrivalwindowicon.svg",
    "/images/NewUiIcons/Arrow.svg",
    "/images/NewUiIcons/arrowicon.svg",
    "/images/NewUiIcons/AttentionIcon.png",
    "/images/NewUiIcons/ChevronLightPurple.svg",
    "/images/NewUiIcons/CloseMini.svg",
    "/images/NewUiIcons/Edit.svg",
    "/images/NewUiIcons/InfoIcon.svg",
    "/images/NewUiIcons/Item Icons.svg",
    "/images/NewUiIcons/ItemIcons2.svg",
    "/images/NewUiIcons/ItemManIcons.png",
    "/images/NewUiIcons/locationicon.svg",
    "/images/NewUiIcons/LocationPin.svg",
    "/images/NewUiIcons/moveezlogo.svg",
    "/images/NewUiIcons/MoverIcons.svg",
    "/images/NewUiIcons/Polygon4.svg",
    "/images/NewUiIcons/Search.svg",
    "/images/NewUiIcons/Subtract Icon.svg",
    "/images/NewUiIcons/SummaryIcons.svg",
    "/images/NewUiIcons/SummaryIcons2.svg",
    "/images/NewUiIcons/Trash Can Icon.svg",
    "/images/NewUiIcons/truckandcrewicon.svg",
    "/images/NewUiIcons/vector1.svg",
    "/images/NewUiIcons/Vector.svg",
    "/images/NewUiIcons/whatsmove.svg",

    // Template-expanded ranges found under public/images
    "/images/s1.svg",
    "/images/s2.svg",
    "/images/s3.svg",
    "/images/s4.svg",
    "/images/s5.svg",
    "/images/s6.svg",
    "/images/s7.svg",
    "/images/s8.svg",
    "/images/s9.svg",

    "/images/partner1.png",
    "/images/partner2.png",
    "/images/partner3.png",
    "/images/partner4.png",
    "/images/partner5.png",
    "/images/partner6.png",

    "/images/ind1.svg",
    "/images/ind2.svg",
    "/images/ind3.svg",
    "/images/ind4.svg",
    "/images/ind5.svg",
    "/images/ind6.svg",
    "/images/ind7.svg",
    "/images/ind8.svg",

    "/images/solution_ic1.svg",
    "/images/solution_ic2.svg",
    "/images/solution_ic3.svg",
    "/images/solution_ic4.svg",

    "/images/step1.png",
    "/images/step2.png",
    "/images/step3.png",
    "/images/step4.png",

    "/images/t1.png",
    "/images/t2.png",
    "/images/t3.png",
  ];

  const loaders = paths.map((p) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve({ path: p, status: "ok" });
      img.onerror = () => resolve({ path: p, status: "error" });
      img.src = encodeURI(p);
    });
  });

  // Wait for all preloads (best-effort). Resolve even if some fail.
  return Promise.all(loaders);
};
